<template><svg class="ico ico__spinner" width="800" height="800" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Loading spinner">
  <path d="M4.5 12.5a8 8 0 1 0 8-8" stroke="currentColor" stroke-width="2"/>
</svg>
</template>